/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Routemize_Core_Dtos_ListResultDto_1 } from '../models/Routemize_Core_Dtos_ListResultDto_1';
import type { Routemize_Core_Dtos_PagedResultDto_1 } from '../models/Routemize_Core_Dtos_PagedResultDto_1';
import type { Routemize_DTOs_AcceptInviteDto } from '../models/Routemize_DTOs_AcceptInviteDto';
import type { Routemize_DTOs_AddUpdateUserAddressDto } from '../models/Routemize_DTOs_AddUpdateUserAddressDto';
import type { Routemize_DTOs_CreateUserDto } from '../models/Routemize_DTOs_CreateUserDto';
import type { Routemize_DTOs_CreateUserInviteDto } from '../models/Routemize_DTOs_CreateUserInviteDto';
import type { Routemize_DTOs_CreateUserWorkingHourDTO } from '../models/Routemize_DTOs_CreateUserWorkingHourDTO';
import type { Routemize_DTOs_CreateUserWorkingHourOverrideDTO } from '../models/Routemize_DTOs_CreateUserWorkingHourOverrideDTO';
import type { Routemize_DTOs_DailyAvailabilityDTO } from '../models/Routemize_DTOs_DailyAvailabilityDTO';
import type { Routemize_DTOs_Identity_IdentityRoleDto_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_ } from '../models/Routemize_DTOs_Identity_IdentityRoleDto_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_';
import type { Routemize_DTOs_Identity_IdentityUserUpdateDto } from '../models/Routemize_DTOs_Identity_IdentityUserUpdateDto';
import type { Routemize_DTOs_Identity_IdentityUserUpdateRolesDto } from '../models/Routemize_DTOs_Identity_IdentityUserUpdateRolesDto';
import type { Routemize_DTOs_OnboardingProgressDto } from '../models/Routemize_DTOs_OnboardingProgressDto';
import type { Routemize_DTOs_SystemAdminInfoDto } from '../models/Routemize_DTOs_SystemAdminInfoDto';
import type { Routemize_DTOs_TeamMemberListDto } from '../models/Routemize_DTOs_TeamMemberListDto';
import type { Routemize_DTOs_UpdateOnboardingProgressDto } from '../models/Routemize_DTOs_UpdateOnboardingProgressDto';
import type { Routemize_DTOs_UpdateUserWorkingHourDTO } from '../models/Routemize_DTOs_UpdateUserWorkingHourDTO';
import type { Routemize_DTOs_UpdateUserWorkingHourOverrideDTO } from '../models/Routemize_DTOs_UpdateUserWorkingHourOverrideDTO';
import type { Routemize_DTOs_UpdateUserWrokingHoursDto } from '../models/Routemize_DTOs_UpdateUserWrokingHoursDto';
import type { Routemize_DTOs_UserAccountDto } from '../models/Routemize_DTOs_UserAccountDto';
import type { Routemize_DTOs_UserAccountDto_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_ } from '../models/Routemize_DTOs_UserAccountDto_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_';
import type { Routemize_DTOs_UserAddressDto } from '../models/Routemize_DTOs_UserAddressDto';
import type { Routemize_DTOs_UserDto } from '../models/Routemize_DTOs_UserDto';
import type { Routemize_DTOs_UserDto_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_ } from '../models/Routemize_DTOs_UserDto_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_';
import type { Routemize_DTOs_UserImageDTO } from '../models/Routemize_DTOs_UserImageDTO';
import type { Routemize_DTOs_UserInviteDto } from '../models/Routemize_DTOs_UserInviteDto';
import type { Routemize_DTOs_UserInviteDto_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_ } from '../models/Routemize_DTOs_UserInviteDto_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_';
import type { Routemize_DTOs_UserWorkingHourDTO } from '../models/Routemize_DTOs_UserWorkingHourDTO';
import type { Routemize_DTOs_UserWorkingHourOverrideDTO } from '../models/Routemize_DTOs_UserWorkingHourOverrideDTO';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UserService {
    /**
     * @param id
     * @returns Routemize_DTOs_UserAccountDto OK
     * @throws ApiError
     */
    public static getApiIdentityUsers(
        id: string,
    ): CancelablePromise<Routemize_DTOs_UserAccountDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/identity/users/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns Routemize_DTOs_UserAccountDto OK
     * @throws ApiError
     */
    public static putApiIdentityUsers(
        id: string,
        requestBody?: Routemize_DTOs_Identity_IdentityUserUpdateDto,
    ): CancelablePromise<Routemize_DTOs_UserAccountDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/identity/users/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiIdentityUsers(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/identity/users/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param filter
     * @param sorting
     * @param skipCount
     * @param maxResultCount
     * @returns Routemize_Core_Dtos_PagedResultDto_1<Routemize_DTOs_UserAccountDto_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_> OK
     * @throws ApiError
     */
    public static getApiIdentityUsers1(
        filter?: string,
        sorting?: string,
        skipCount?: number,
        maxResultCount?: number,
    ): CancelablePromise<Routemize_Core_Dtos_PagedResultDto_1> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/identity/users',
            query: {
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
        });
    }
    /**
     * @param id
     * @returns Routemize_Core_Dtos_ListResultDto_1<Routemize_DTOs_Identity_IdentityRoleDto_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_> OK
     * @throws ApiError
     */
    public static getApiIdentityUsersRoles(
        id: string,
    ): CancelablePromise<Routemize_Core_Dtos_ListResultDto_1> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/identity/users/{id}/roles',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static putApiIdentityUsersRoles(
        id: string,
        requestBody?: Routemize_DTOs_Identity_IdentityUserUpdateRolesDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/identity/users/{id}/roles',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns Routemize_Core_Dtos_ListResultDto_1<Routemize_DTOs_Identity_IdentityRoleDto_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_> OK
     * @throws ApiError
     */
    public static getApiIdentityUsersAssignableRoles(): CancelablePromise<Routemize_Core_Dtos_ListResultDto_1> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/identity/users/assignable-roles',
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_DTOs_UserInviteDto OK
     * @throws ApiError
     */
    public static postApiAppUserCreateInvite(
        requestBody?: Routemize_DTOs_CreateUserInviteDto,
    ): CancelablePromise<Routemize_DTOs_UserInviteDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/user/createInvite',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param sorting
     * @param skipCount
     * @param maxResultCount
     * @returns Routemize_Core_Dtos_PagedResultDto_1<Routemize_DTOs_UserInviteDto_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_> OK
     * @throws ApiError
     */
    public static getApiAppUserGetInviteList(
        sorting?: string,
        skipCount?: number,
        maxResultCount?: number,
    ): CancelablePromise<Routemize_Core_Dtos_PagedResultDto_1> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/user/getInviteList',
            query: {
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
        });
    }
    /**
     * @param id
     * @returns Routemize_DTOs_UserInviteDto OK
     * @throws ApiError
     */
    public static getApiAppUserGetInviteById(
        id: string,
    ): CancelablePromise<Routemize_DTOs_UserInviteDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/user/{id}/getInviteById',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_DTOs_UserAccountDto OK
     * @throws ApiError
     */
    public static postApiAppUserCreate(
        requestBody?: Routemize_DTOs_CreateUserDto,
    ): CancelablePromise<Routemize_DTOs_UserAccountDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/user/create',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_DTOs_UserAccountDto OK
     * @throws ApiError
     */
    public static putApiAppUserUpdateMany(
        requestBody?: Array<Routemize_DTOs_UpdateUserWrokingHoursDto>,
    ): CancelablePromise<Array<Routemize_DTOs_UserAccountDto>> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/app/user/updateMany',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns Routemize_DTOs_UserDto OK
     * @throws ApiError
     */
    public static getApiAppUserGetAllUsers(): CancelablePromise<Array<Routemize_DTOs_UserDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/user/getAllUsers',
        });
    }
    /**
     * @returns Routemize_DTOs_TeamMemberListDto OK
     * @throws ApiError
     */
    public static getApiAppUserGetTeamMembers(): CancelablePromise<Array<Routemize_DTOs_TeamMemberListDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/user/getTeamMembers',
        });
    }
    /**
     * @param userId
     * @returns Routemize_DTOs_UserDto OK
     * @throws ApiError
     */
    public static getApiAppUserGetUserById(
        userId: string,
    ): CancelablePromise<Routemize_DTOs_UserDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/user/getUserById/{userId}',
            path: {
                'userId': userId,
            },
        });
    }
    /**
     * @param userId
     * @param formData
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppUserUploadImage(
        userId: string,
        formData?: {
            file?: Blob;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/user/uploadImage/{userId}',
            path: {
                'userId': userId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * @param userId
     * @returns Routemize_DTOs_UserImageDTO OK
     * @throws ApiError
     */
    public static getApiAppUserGetImage(
        userId: string,
    ): CancelablePromise<Array<Routemize_DTOs_UserImageDTO>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/user/getImage/{userId}',
            path: {
                'userId': userId,
            },
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppUserCreateUserAddress(
        requestBody?: Routemize_DTOs_AddUpdateUserAddressDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/user/createUserAddress',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param userId
     * @returns Routemize_DTOs_UserAddressDto OK
     * @throws ApiError
     */
    public static getApiAppUserGetUserAddresses(
        userId: string,
    ): CancelablePromise<Array<Routemize_DTOs_UserAddressDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/user/getUserAddresses/{userId}',
            path: {
                'userId': userId,
            },
        });
    }
    /**
     * @param addressId
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiAppUserDeleteUserAddress(
        addressId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/app/user/deleteUserAddress/{addressId}',
            path: {
                'addressId': addressId,
            },
        });
    }
    /**
     * @param userId
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiAppUserDeleteUser(
        userId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/app/user/deleteUser/{userId}',
            path: {
                'userId': userId,
            },
        });
    }
    /**
     * @param inviteId
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppUserCancelInvite(
        inviteId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/user/cancelInvite/{inviteId}',
            path: {
                'inviteId': inviteId,
            },
        });
    }
    /**
     * @param inviteId
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppUserResendInvite(
        inviteId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/user/resendInvite/{inviteId}',
            path: {
                'inviteId': inviteId,
            },
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_DTOs_UserAccountDto OK
     * @throws ApiError
     */
    public static postApiAppUserAcceptInvite(
        requestBody?: Routemize_DTOs_AcceptInviteDto,
    ): CancelablePromise<Routemize_DTOs_UserAccountDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/user/acceptInvite',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppUserCreateUserWorkHourAysnc(
        requestBody?: Array<Routemize_DTOs_CreateUserWorkingHourDTO>,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/user/createUserWorkHourAysnc',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static putApiAppUserUpdateUserWorkHourAysnc(
        requestBody?: Array<Routemize_DTOs_UpdateUserWorkingHourDTO>,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/app/user/updateUserWorkHourAysnc',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiAppUserDeleteUserWorkHours(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/app/user/{id}/deleteUserWorkHours',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param userId
     * @returns Routemize_DTOs_UserWorkingHourDTO OK
     * @throws ApiError
     */
    public static getApiAppUserGetUserWorkHourAysnc(
        userId: string,
    ): CancelablePromise<Array<Routemize_DTOs_UserWorkingHourDTO>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/user/getUserWorkHourAysnc/{userId}',
            path: {
                'userId': userId,
            },
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppUserCreateUserWorkHourOverrideAysnc(
        requestBody?: Array<Routemize_DTOs_CreateUserWorkingHourOverrideDTO>,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/user/createUserWorkHourOverrideAysnc',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static putApiAppUserUpdateUserWorkHourOverrideAysnc(
        requestBody?: Array<Routemize_DTOs_UpdateUserWorkingHourOverrideDTO>,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/app/user/updateUserWorkHourOverrideAysnc',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiAppUserDeleteUserWorkHoursOverride(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/app/user/{id}/deleteUserWorkHoursOverride',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param userId
     * @returns Routemize_DTOs_UserWorkingHourOverrideDTO OK
     * @throws ApiError
     */
    public static getApiAppUserGetUserWorkHourOverrideAysnc(
        userId: string,
    ): CancelablePromise<Array<Routemize_DTOs_UserWorkingHourOverrideDTO>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/user/getUserWorkHourOverrideAysnc/{userId}',
            path: {
                'userId': userId,
            },
        });
    }
    /**
     * @param userId
     * @param days
     * @returns Routemize_DTOs_DailyAvailabilityDTO OK
     * @throws ApiError
     */
    public static getApiAppUserGetUserAvailability(
        userId: string,
        days: number = 5,
    ): CancelablePromise<Array<Routemize_DTOs_DailyAvailabilityDTO>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/user/getUserAvailability/{userId}',
            path: {
                'userId': userId,
            },
            query: {
                'days': days,
            },
        });
    }
    /**
     * @returns boolean OK
     * @throws ApiError
     */
    public static getApiAppUserGetOnboardingStatus(): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/user/getOnboardingStatus',
        });
    }
    /**
     * @returns Routemize_DTOs_OnboardingProgressDto OK
     * @throws ApiError
     */
    public static getApiAppUserGetOnboardingProgress(): CancelablePromise<Routemize_DTOs_OnboardingProgressDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/user/getOnboardingProgress',
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static putApiAppUserUpdateOnboardingProgress(
        requestBody?: Routemize_DTOs_UpdateOnboardingProgressDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/app/user/updateOnboardingProgress',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppUserCompleteOnboarding(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/user/completeOnboarding',
        });
    }
    /**
     * @param filter
     * @param roleId
     * @param isActive
     * @param sorting
     * @param skipCount
     * @param maxResultCount
     * @returns Routemize_Core_Dtos_PagedResultDto_1<Routemize_DTOs_UserDto_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_> OK
     * @throws ApiError
     */
    public static getApiAppUserGetUsers(
        filter?: string,
        roleId?: string,
        isActive?: boolean,
        sorting?: string,
        skipCount?: number,
        maxResultCount?: number,
    ): CancelablePromise<Routemize_Core_Dtos_PagedResultDto_1> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/user/getUsers',
            query: {
                'Filter': filter,
                'RoleId': roleId,
                'IsActive': isActive,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
        });
    }
    /**
     * @returns Routemize_DTOs_SystemAdminInfoDto OK
     * @throws ApiError
     */
    public static getApiAppUserGetSystemAdminInfo(): CancelablePromise<Routemize_DTOs_SystemAdminInfoDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/user/getSystemAdminInfo',
        });
    }
}
